/**
 * @generated SignedSource<<8b8f3d01eddc3087c537ebd7be16ceaa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type SinglePeriodMetric = "ENGAGEMENT" | "PRODUCT_DATE_TRACKER_REGISTERED" | "PRODUCT_DATE_TRACKER_TASKS_COMPLETED" | "TASK_EXECUTIONS_COMPLETED" | "TODO_CREATED" | "TODO_ISSUE_CREATED" | "TODO_ISSUE_RESOLVED" | "TODO_ISSUE_RESOLVED_AVG_TIME" | "TODO_RESOLVED" | "TODO_RESOLVED_AVG_TIME";
import { FragmentRefs } from "relay-runtime";
export type SinglePeriodTableTopAndBottom$data = {
  readonly dimensions: ReadonlyArray<{
    readonly id: string;
    readonly label: string;
    readonly " $fragmentSpreads": FragmentRefs<"SinglePeriodTableTopAndBottomTableRow_SinglePeriodAnalyticsDimension">;
  }>;
  readonly metrics: ReadonlyArray<{
    readonly isAggregated: boolean | null;
    readonly metric: SinglePeriodMetric;
  }>;
  readonly " $fragmentType": "SinglePeriodTableTopAndBottom";
};
export type SinglePeriodTableTopAndBottom$key = {
  readonly " $data"?: SinglePeriodTableTopAndBottom$data;
  readonly " $fragmentSpreads": FragmentRefs<"SinglePeriodTableTopAndBottom">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SinglePeriodTableTopAndBottom",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SinglePeriodAnalyticsMetric",
      "kind": "LinkedField",
      "name": "metrics",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAggregated",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "metric",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SinglePeriodAnalyticsDimension",
      "kind": "LinkedField",
      "name": "dimensions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SinglePeriodTableTopAndBottomTableRow_SinglePeriodAnalyticsDimension"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SinglePeriodAnalytics",
  "abstractKey": null
};

(node as any).hash = "7c87c89fad4967e7fd2e1d578f602dda";

export default node;
